<div class="flex justify-content-center align-items-center h-full">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4.16667V15.8333M4.16667 10H15.8333" [attr.stroke]="stroke()" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
